import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { builder } from '@builder.io/react';
import { ApolloClient, InMemoryCache, from, HttpLink, ApolloProvider } from '@apollo/client';
import App from './App';
import './AudioContextMonkeyPatch';
import { appReducer } from './redux/reducer';
import * as serviceWorker from './serviceWorker';
import { setContext } from '@apollo/client/link/context';
import firebase from 'firebase/app';
import { getApiUrl } from './firebase/firebase';
import './main.scss';

builder.init(process.env.REACT_APP_BUILDER_KEY as string);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const firebaseFunctionsLink = setContext(async (_, { headers }) => {
  const idToken = (await firebase.auth().currentUser?.getIdToken()) || '';
  return {
    headers: {
      ...headers,
      authorization: idToken,
    },
  };
});

const httpLink = new HttpLink({ uri: getApiUrl() });

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([firebaseFunctionsLink, httpLink]),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={createStore(appReducer)}>
      <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
